var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "@wordpress/element";
import { CustomFieldEntityType, } from "../../../../types/custom-field";
import { useCustomFieldActions } from "../../../hooks/actions/useCustomFieldActions";
import { UserPageAppContext } from "../../../providers/UserPageAppContextProvider";
import { CustomField as CustomFieldComponent } from "../CustomField/CustomField";
function CustomFieldsWrap({ entityId, entityType, entity, customFields, }) {
    const { state: { cf, userId }, } = useContext(UserPageAppContext);
    const { updateCustomFieldValue } = useCustomFieldActions();
    const valueChangeEnabled = entityType === CustomFieldEntityType.User ||
        (entityType === CustomFieldEntityType.Task &&
            "assigned_users" in entity &&
            entity.assigned_users.some((user) => user.id === userId));
    const saveCustomFieldValueChange = (customFieldId, value) => __awaiter(this, void 0, void 0, function* () {
        yield updateCustomFieldValue(entityId, entityType, customFieldId, value);
    });
    if (!cf || !customFields) {
        return null;
    }
    return (_jsx("div", { className: "wpqt-flex wpqt-flex-col wpqt-items-center wpqt-gap-3", children: customFields.map((cf) => (_jsx(CustomFieldComponent, { data: cf, valueChangeEnabled: valueChangeEnabled, saveCustomFieldValueChange: saveCustomFieldValueChange }, cf.id))) }));
}
export { CustomFieldsWrap };
